module.exports = __webpack_public_path__ + "img/Flag_RD1.faaccdc5.png";